import { SelectProps } from "@amzn/awsui-components-react";
import { Stage } from "./lusca-search-api/generated-src";

const BASE_16_CUSTOM_DARK_THEME = {
  base00: "#0f1b2a",
  base01: "white",
  base02: "rgb(88, 110, 117)",
  base03: "white",
  base04: "rgb(88, 110, 117)",
  base05: "white",
  base06: "white",
  base07: "rgb(233, 235, 237)",
  base08: "rgb(38, 139, 210)",
  base09: "rgb(203, 75, 22)",
  base0A: "white",
  base0B: "rgb(133, 153, 0)",
  base0C: "rgb(133, 153, 0)",
  base0D: "rgb(88, 110, 117)",
  base0E: "white",
  base0F: "rgb(38, 139, 210)",
};

const LIGHT_THEME = "light";
const DARK_THEME = "dark";

export const STAGE_OPTIONS: SelectProps.Option[] = [
  { label: Stage.Beta, value: Stage.Beta },
  { label: Stage.Gamma, value: Stage.Gamma },
  { label: Stage.Prod, value: Stage.Prod },
];

export const DESTINATION_OPTIONS: SelectProps.Option[] = [
  { label: "Flare", value: "FLARE" },
  { label: "rACE", value: "RACE" },
  { label: "None", value: "NONE" },
];

export const DIFF_UNCHANGED_LINES_CONFIG = {
  threshold: 5,
  margin: 3,
  expandMoreLinesLimit: 5,
};

const PERMISSION_LINK =
  "https://permissions.amazon.com/a/team/amzn1.abacus.team.nxghcmvq7dyzqkzpwd5a";

const EMP_PROVIDERS = {
  APPLE: "amzn1.emp.provider.apple-partner-billing",
  GOOGLE: "amzn1.emp.provider.google-in-app",
  FUSE: "amzn1.emp.provider.fuse",
} as const;

const PAYMENT_METHODS = {
  APPLE: "Apple",
  GOOGLE: "Google",
  FUSE: "Fuse",
  EMP: "EMP",
  DIRECT_DEBIT: "Direct Debit",
  AMP: "AMP",
  CREDIT_CARD: "Credit Card",
} as const;

const EMP_TO_PAYMENT_METHOD: Record<string, string> = {
  [EMP_PROVIDERS.APPLE]: PAYMENT_METHODS.APPLE,
  [EMP_PROVIDERS.GOOGLE]: PAYMENT_METHODS.GOOGLE,
  [EMP_PROVIDERS.FUSE]: PAYMENT_METHODS.FUSE,
};

const DIGITAL_ORDER_SOURCES = {
  ARK: "ARK",
  FOIL: "FOIL",
} as const;

export {
  BASE_16_CUSTOM_DARK_THEME,
  LIGHT_THEME,
  DARK_THEME,
  PERMISSION_LINK,
  EMP_PROVIDERS,
  PAYMENT_METHODS,
  EMP_TO_PAYMENT_METHOD,
  DIGITAL_ORDER_SOURCES,
};
